// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alertas-dashboard {
  font-size: 0.9rem;
  margin-top: 1rem;
}

.alertas-dashboard table {
  width: 100%;
  border-collapse: collapse;
}

.alertas-dashboard th,
.alertas-dashboard td {
  border: 1px solid #ccc;
  padding: 0.4rem;
  text-align: left;
}

.alerta-activa {
  background-color: #ffe6e6;
  animation: parpadeo 1s infinite;
}

.icono-alerta {
  animation: parpadeo 1s infinite;
}

@keyframes parpadeo {
  0% { opacity: 1; }
  50% { opacity: 0; }
  100% { opacity: 1; }
}
`, "",{"version":3,"sources":["webpack://./src/styles/AlertasDashboard.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,KAAK,UAAU,EAAE;EACjB,MAAM,UAAU,EAAE;EAClB,OAAO,UAAU,EAAE;AACrB","sourcesContent":[".alertas-dashboard {\n  font-size: 0.9rem;\n  margin-top: 1rem;\n}\n\n.alertas-dashboard table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.alertas-dashboard th,\n.alertas-dashboard td {\n  border: 1px solid #ccc;\n  padding: 0.4rem;\n  text-align: left;\n}\n\n.alerta-activa {\n  background-color: #ffe6e6;\n  animation: parpadeo 1s infinite;\n}\n\n.icono-alerta {\n  animation: parpadeo 1s infinite;\n}\n\n@keyframes parpadeo {\n  0% { opacity: 1; }\n  50% { opacity: 0; }\n  100% { opacity: 1; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
